import { asyncAction } from 'lib/actions';

export const fetchOtherArtistWorksListAction = asyncAction('otherArtistWorks/FETCH_OTHER_ARTIST_WORKS');
